import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLivejournalComponent } from './simple-icons-livejournal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLivejournalComponent ],
    exports:      [ SimpleIconsLivejournalComponent ],
    bootstrap:    []
})
export class SimpleIconsLivejournalModule {}
